<template>
  <div class="col-sm-11">
    <div class="row">
      <div class="col-sm-4 details__thumb">
        <ArtworkImage :internetAuction="internetAuction" />
      </div>
      <div
        v-html="internetAuction.artwork.catalogNumber"
        class="headings--h2 artwork-number d-none"
      />
      <div class="col details__desc pt-0">
        <div class="row">
          <div class="col-lg-8">
            <ArtistDetails
              v-if="artwork.artist"
              :artist="artwork.artist"
              class="headings--h2"
              @click.native="setAuctionModal"
            />
            <div
              v-else
              class="headings--h2"
              @click="setAuctionModal"
            >
              {{ artwork.name }}
            </div>
            <div class="details__art-desc">
              <h4
                v-if="artwork.artist"
                class="text--muted"
              >
                {{ artwork.name }}
              </h4>
              <p
                v-if="artwork.description"
                v-html="artwork.description.substring(0, 230)"
                class="text--muted m-0"
              />
            </div>
          </div>
          <div class="col-lg-4 my-3 my-lg-0">
            <InternetAuctionCountdown
              v-if="auctionStateIsStarted"
              :time-to-calculate="{
                endDate: internetAuction.endDate,
                type: 'artwork',
                isOvertime: internetAuction.isOvertime,
              }"
            />
            <p
              v-if="!!userId && userIsLastBidder"
              class="internet_auction-last-bidder price--highlight mt-2 mt-lg-0 ml-lg-auto mb-0"
            >
              {{ I18n.t("artworks.you_lead") }}
            </p>
          </div>
          <div class="col-12">
            <div class="row details__actions internet_auction-details">
              <div class="col-md-12 col-lg-4 col-xl-3 mb-1 mb-sm-3">
                <p class="headings--h4">
                  {{ I18n.t("artworks.starting_price_label")}}
                </p>
                <p>
                  {{ I18n.t("artworks.price", { price: formatPrice(artwork.startingPrice) }) }}
                  <span v-if="artwork.droitDeSuite" class="price price--plus-droit-de-suite pl-1">
                    {{ I18n.t("artworks.droit_de_suite") }}
                  </span>
                </p>
              </div>
              <div
                v-if="isArtworkEstimationPresent"
                class="col-md-12 col-lg-4 col-xl-3 mb-1 mb-sm-3 estimation"
              >
                <p class="headings--h4">
                  {{ I18n.t("artworks.estimation_label") }}
                </p>
                <p>
                  {{ I18n.t("artworks.estimated_prices_with_currency",
                    { price_min: formatPrice(artwork.estimationMin),
                      price_max: formatPrice(artwork.estimationMax) }) }}
                </p>
              </div>
              <ArtworkState
                class="col-md-12 col-lg-4 col-xl-3 mb-1 mb-sm-3"
                :internetAuction="internetAuction"
              />
              <div class="col-md-6 col-lg-4 col-xl-3 ml-lg-auto mt-xl-0">
                <p
                  v-if="showCurrentLimit"
                  class="user-limit-info text-left text-lg-center"
                >
                  {{ I18n.t("internet_auctions.user_limit") }}
                  <b>{{ currentLimit }}</b>
                </p>
                <button
                  class="btn btn__default w-100"
                  @click="setAuctionModal"
                >
                  {{ btnText }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapMutations, mapState } from 'vuex';
  import InternetAuctionCountdown from '@/internet_auctions/components/internet_auction_countdown';
  import { formatNumber } from '@/shared/helpers';
  import { AUCTION_STARTED_STATE } from '@/internet_auctions/consts';
  import ArtistDetails from '@/shared/components/artist_details';
  import ArtworkImage from './artwork_image';
  import ArtworkState from './artwork_state';

  export default {
    name: 'ArtworkDetails',
    components: {
      InternetAuctionCountdown,
      ArtworkImage,
      ArtistDetails,
      ArtworkState,
    },
    props: {
      internetAuction: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        formatPrice: formatNumber,
      };
    },
    methods: {
      ...mapMutations(['SET_ACTIVE_MODAL_AUCTION_ID']),
      setAuctionModal() {
        this.SET_ACTIVE_MODAL_AUCTION_ID(this.internetAuction.id);
      },
    },
    computed: {
      ...mapState(['userId']),
      auctionStateIsStarted() {
        return this.internetAuction.state === AUCTION_STARTED_STATE;
      },
      artwork() {
        return this.internetAuction.artwork;
      },
      isArtworkEstimationPresent() {
        return this.artwork.estimationMin && this.artwork.estimationMax;
      },
      userIsLastBidder() {
        return this.internetAuction.lastBidUserId === this.userId;
      },
      currentLimit() {
        return `${this.formatPrice(this.internetAuction.userLimit)} zł`;
      },
      btnText() {
        if (this.auctionStateIsStarted) {
          return this.I18n.t('internet_auctions.bid');
        }
        return this.I18n.t('internet_auctions.see');
      },
      showCurrentLimit() {
        return this.internetAuction.userLimit &&
        (this.internetAuction.userLimit > this.internetAuction.value);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/internet_auctions/components/artwork/artwork_details.vue?564c5423